import Header from "@/components/landing/Header";
import About from "@/components/landing/About";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";

export default function UeberUns() {
  return (
    <>
      <Seo
        title="Über uns: Ihre Strategin für den Weg in die USA"
        description="International Business & Relocation Strategist: U.S. Market Entry, Business Development und Immigration Case Coordination – Beratung aus eigener Auswanderungserfahrung, auf Deutsch."
        keywords="International Business Strategist, U.S. Market Entry, Immigration Case Coordination, Auswanderungsberatung Florida, Relocation Beraterin"
      />
      <Header />
      <main className="pt-20" data-testid="ueber-uns-page">
        <About />
      </main>
      <Footer />
    </>
  );
}
